import ApplicationController from "../../application_component_controller"
import { useListen } from "hb/insights/use_listen"

export default class extends ApplicationController {
  static values = {
    querySessionId: String,
    widgetId: String
  }

  connect() {
    useListen(this)

    this.listenWindow("queryTsChanged", this.queryTsChanged)
  }

  queryTsChanged({ts, querySessionId}) {
    if (querySessionId !== this.querySessionIdValue) return

    const overrideCheckbox = this.element.querySelector('[data-config-field="override_time"]')

    if (overrideCheckbox && overrideCheckbox.checked) {
      this.emitWindow("dashboard:updateProductWidgetConfig", {
        widgetId: this.widgetIdValue, field: "ts", value: ts
      })
    }
  }
}
